<script lang="ts" setup>
import { onMounted, useTemplateRef } from "vue";
import { useDraggable, useElementSize } from "@vueuse/core";
import TextButton from "@/shared/components/TextButton/TextButton.vue";

defineProps<{
  userId: string;
}>();

defineEmits<{
  stopImpersonation: [];
}>();

const impersonationInfo = useTemplateRef("impersonationInfo");
const { width: impersonationInfoWidth, height: impersonationInfoHeight } =
  useElementSize(impersonationInfo);
const { x, y, style, isDragging } = useDraggable(impersonationInfo, {
  initialValue: { x: 0, y: 0 },
});

onMounted(() => {
  if (typeof window === "undefined") return;

  x.value = window.innerWidth / 2 - impersonationInfoWidth.value / 2; // center horizontally
  y.value = window.innerHeight - impersonationInfoHeight.value - 24; // position above bottom with some margin
});
</script>

<template>
  <div
    ref="impersonationInfo"
    class="impersonation-info"
    :style="style"
    :data-is-dragging="isDragging"
  >
    <span>{{ $t("dashboard.superuser.info") }}</span>
    <span>{{ userId }}</span>
    <TextButton
      :caption="$t('dashboard.superuser.stop')"
      color="white"
      icon="close"
      display="inline"
      @click="$emit('stopImpersonation')"
    />
  </div>
</template>

<style scoped>
@import "ImpersonationInfo.css";
</style>
